import React, { useEffect, useState } from 'react';

import '../../scss/valueInclusive/FriendtoForward.scss';

import { AxiosResponse } from 'axios';

import { httpModules } from '@app/helpers/http.module'; // Adjust path as per your setup

interface ISpacialHeadline {
	specialsID: number;
	specialsHeadline: string;
}

interface SpacialHeadlinesProps {
	specialsId: string | null;
}

export const SpacialHeadlines: React.FC<SpacialHeadlinesProps> = ({ specialsId }) => {
	const [spacialHeadline, setspacialHeadline] = useState<Array<ISpacialHeadline>>([]);

	useEffect(() => {
		if (specialsId) {
			const apiUrl = `api/bridge/v1/FriendForward-form/SpecialsHeadline?specialsid=${specialsId}`;
			httpModules
				.get<Array<ISpacialHeadline>>(apiUrl)
				.then((response: AxiosResponse<Array<ISpacialHeadline>>) => {
					setspacialHeadline(response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}, []);

	const subtitle = `Send this special to your friend: ${spacialHeadline.length > 0 ? spacialHeadline[0].specialsHeadline : ''}`;

	return (
		<div className="col-12 col-md-6	 content-halign_center form font-family_primary font-weight_regular text-size_medium">
			<div className="col-12 content-halign_center form-title-sec">
				<h1>Forward To A Friend</h1>
				<p>{subtitle}</p>
			</div>
		</div>
	);
};
